<template>
  <form @submit.prevent="handleSubmit" :class="$style.form">
    <dl :class="[$style.form__inputs, $style.inputs]">
      <div :class="$style.inputs__row">
        <dt :class="$style.inputs__name">{{ inputName }}</dt>
        <dd :class="$style.inputs__value">
          <div :class="$style.wrapper__input">
            <DolphinPasswordInput
              v-if="inputType === 'password'"
              v-model="value"
              @validateChange="handleValidateChange"
            />
            <AppEmailInput
              v-if="inputType === 'email'"
              v-model="value"
              :class="[$style.inputs__input, $style.inputs__input_password]"
              @validateChange="handleValidateChange"
            />
          </div>
        </dd>
      </div>
    </dl>
    <div :class="$style.form__action">
      <FlatButton
        type="submit"
        :disabled="isSubmitDisabled"
        :class="$style.button"
        variant="primary"
        size="medium"
      >
        {{ sendButtonText }}
      </FlatButton>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import type { ValidateChangeEventParams as AppEmailInputValidateChangeEventParams } from '@/components/molecules/AppEmailInput.vue'
import AppEmailInput from '@/components/molecules/AppEmailInput.vue'
import type { ValidateChangeEventParams as DolphinPasswordInputValidateChangeEventParams } from '@/features/password/components/DolphinPasswordInput.vue'
import DolphinPasswordInput from '@/features/password/components/DolphinPasswordInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

const props = withDefaults(
  defineProps<{
    modelValue: string
    inputName: string
    inputType: 'email' | 'password'
    sendButtonText: string
    submitDisabled?: boolean
  }>(),
  {
    submitDisabled: false,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
  (event: 'submit'): void
}>()

// TODO: データ持つ部分とValidationが分離しちゃってるので、修正する
const isInvalid = ref(true)
const value = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emit('update:modelValue', value)
  },
})

const isSubmitDisabled = computed(
  (): boolean =>
    props.submitDisabled || props.modelValue.length === 0 || isInvalid.value
)

const handleSubmit = (): void => {
  if (isSubmitDisabled.value) {
    return
  }
  emit('submit')
}

const handleValidateChange = ({
  isValid,
}:
  | AppEmailInputValidateChangeEventParams
  | DolphinPasswordInputValidateChangeEventParams): void => {
  isInvalid.value = !isValid
}
</script>

<style lang="scss" module>
.form {
  &__action {
    display: flex;
    align-items: center;
    justify-content: center;

    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}

.inputs {
  &__name {
    color: $color-text-and-object-high-emphasis;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  &__row {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }

  &__value {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__input {
    width: 100%;
  }
}

.button {
  font-size: 14px;
}
</style>
